import { mapState } from "vuex";

/**
 * Mixin to hide/restore onboarding popovers when a modal is opened/closed.
 *
 * Usage:
 *   import onboardingPopoverMixin from "@/mixins/onboardingPopoverMixin";
 *   mixins: [onboardingPopoverMixin],
 *
 * Then call this.onModalShow() when the modal opens (e.g. @shown, @show)
 * and this.onModalHidden() when the modal closes (e.g. @hidden, @hide, or in a closed() method).
 */
const onboardingPopoverMixin = {
	data() {
		return {
			hiddenPopover: null
		};
	},
	computed: {
		...mapState({
			onboarding: state => state.onboarding
		})
	},
	methods: {
		onModalShow() {
			const popoverKeys = [
				"showPopoverLogo",
				"showPopoverNumbering",
				"showPopoverCompany",
				"showPopoverPayment",
				"showPopoverBankDetails",
				"showPopoverEndOnboarding"
			];
			this.hiddenPopover = popoverKeys.find(key => this.onboarding[key]) || null;
			if (this.hiddenPopover) {
				this.$store.commit(this.hiddenPopover, false);
			}
		},
		onModalHidden() {
			if (this.hiddenPopover) {
				this.$store.commit(this.hiddenPopover, true);
				this.hiddenPopover = null;
			}
		}
	}
};

export default onboardingPopoverMixin;
